import axios from '../index'

export default {
    getInstitucion (params) {
        return axios.get('/instituciones/usuario/', {
            params
        })
    },
    getCiclosEscolares (institucionId) {
        return axios.get('/ciclos-escolares/ciclosPorInstitucion/'+ institucionId)
    },
    getPrograma (institucionId) {
        return axios.get('/programas/institucion/'+ institucionId)
    },
    getGradoAcademico(programa){
        return axios.get('/atributos/porPrograma/' + programa)
    },
    getGrupo (institucionId, params){
        return axios.get('/grupos-administrativos/gruposInstitucion/' + institucionId, {
            params
        })
    },
    getInscripcionMasiva(params){
        return axios.get('/proceso-inscripcion/statusCiclo',{
            params
        })

    },
    getEliminarInscripcion(formData){
        return axios.post('/proceso-inscripcion/deleteInscripcion', formData)
    },

    // GESTION DE SERVICIOS ESCOLARES 
    getGuardarFestion(institucion, cicloEscolarId, formData) {
        return axios.post('/api/v1/instituciones/ciclos-escolares/' + institucion + '/ciclo-escolar/' + cicloEscolarId + '/cambiar-estatus', formData)
    },
    getInfoGestion(params) {
        return axios.get('/api/v1/instituciones/ciclos-escolares/filtrar', {params})
    },
    getCicloGestion(){
        return axios.get('/ciclos-escolares-por-institucion')
    },

    // MATRICULA 
    
    getPeriodo(programa){
        return axios.get('/programas/grados/' + programa)
    },
    getMatriculas(params){
        return axios.get('/alumnos/paginate', {params})
    },
    postEditarMatricula(id, formData){
        return axios.post('/alumnos/grado/edit/' + id, formData)
    },

    // DESVINCULAR ALUMNO
    getDesvincularAlumno(params){
        return axios.get('/api/v1/familias/getFamilias',  {params})
    },
    postDesvincularFamiliar(payload){
        return axios.post('/api/v1/familias/DevincularHermano', payload)
    },

    // FOTOGRAFÍAS MASIVAS
    postBorrarFotografias(payload){
        return axios.post('/api/personas/deleteBulkImages', payload)
    },

    // BECAS MASIVAS
    getAsinarBecasMasiva(params){
        return axios.get('/becas/listado-becas', {params})
    },
    getCategoriasAsignarBeca(){
        return axios.get('/becas/categorias')
    },
    getBecaAsignarBeca(institucion, categoria){
        return axios.get('/becas/opciones/' + institucion + '/' + categoria)
    },
    postAsignarBecaMasivo(params){
        return axios.post('/becas/asignar-becas-masivo', params)
    },
}